import { pb } from './pb'

const handleJsonResponse = async resp => {
  let json = {}
  try {
    json = await resp.json()
  } catch (err) {
    throw new Error('Incorrect respnse format, status: ' + resp.status)
  }
  if (resp.status !== 200)
    throw new Error(json?.message || 'Untitled server fail: ' + resp.status)
  else if (json?.success === false)
    throw new Error(json?.message || 'Untitled server fail: ' + resp.status)
  else if (json?.success === true && 'data' in json)
    return json.data
  else
    return json
}

const handleTextResponse = async resp => {
  const text = await resp.text()
  if (resp.status === 200)
    return text
  else
    throw new Error(text)
}

const pbReqDefaults = (headers = {}, body = undefined, method = !!body ? 'post' : 'get') => ({
  cache: 'no-store',
  signal: AbortSignal.timeout(5000),
  headers: {
    'Authorization': pb.authStore.token,
    ...headers
  },
  body,
  method,
})

export const authTokenValid = async () => !pb?.authStore?.token ? false : await fetch(
  `${pb.baseURL}/api/is-auth-token-valid`,
  pbReqDefaults(),
).then(({ status }) => status !== 401).catch(err => false)

export const getServerVersion = async () => await fetch(
  `${pb.baseURL}/api/version`,
  pbReqDefaults(),
).then(handleTextResponse)

export const getRefidsForSeries = async (seriesIds) => await fetch(
  `${pb.baseURL}/api/rfid/generate/${seriesIds.join(',')}`,
  pbReqDefaults(),
).then(handleTextResponse)

export const requestAuthByOutgoingCall = async ({ phoneNumber, requestID }) => await fetch(
  `${pb.baseURL}/api/auth-by-outgoing-call`,
  pbReqDefaults({ 'Content-Type': 'application/json', }, JSON.stringify({ phoneNumber, requestID }))
).then(handleJsonResponse)

export const integrationConfig = async (config) => await fetch(
  `${pb.baseURL}/api/integration/config`,
  pbReqDefaults({ 'Content-Type': 'application/json', }, JSON.stringify(config))
).then(handleJsonResponse)

export let serverTimeOffset = 0

export const timesync = async () => {
  const berforeTimesync = Date.now()
  let afterTimesync = 0
  return await fetch(
    `${pb.baseURL}/api/timesync`,
    pbReqDefaults(),
  ).then(r => {
    afterTimesync = Date.now()
    return handleTextResponse(r)
  }).then(serverTimestamp => {
    serverTimeOffset = +serverTimestamp - (berforeTimesync + (afterTimesync - berforeTimesync) / 2)
  })
}
